module.exports = __webpack_public_path__ + "img/7.bf13a667.jpg";